export function configureBrowserViewport() {
  const userAgent = navigator.userAgent;
  // iOS Chrome's desktop request uses a Macintosh UA with CriOS, without Mobile.
  // Desktop Chrome on a Mac uses Chrome instead of CriOS.
  const requestedIOSDesktop = /\bMacintosh\b/.test(userAgent) &&
    /\bCriOS\/\d+/.test(userAgent) && !/\bMobile\b/.test(userAgent);
  if (!requestedIOSDesktop) return;

  const viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!viewport) return;

  // Let WebKit fit the desktop canvas to the phone; initial-scale=1 would keep
  // it zoomed into one corner. Other directives and pinch zoom remain available.
  const directives = viewport.content.split(",")
    .map(value => value.trim())
    .filter(value => value && !/^(width|initial-scale)\s*=/i.test(value));
  viewport.content = ["width=1440", ...directives].join(", ");
}

export function updateAppViewportHeight(viewport: Pick<VisualViewport, "width" | "height">) {
  // A fitted desktop page starts below scale=1. Compare viewport widths to
  // distinguish that fit from a user's pinch zoom before handling the keyboard.
  if (Math.abs(viewport.width - document.documentElement.clientWidth) > 1) return;
  if (viewport.height < window.innerHeight - 100) {
    document.documentElement.style.setProperty("--app-height", `${viewport.height}px`);
  } else {
    document.documentElement.style.removeProperty("--app-height");
  }
}
